<template>
  <div class="w-full">
    <vs-popup
        v-if="open"
        :active.sync="modalQuitar"
        title="Quitar Conta a Pagar"
    >
      <div
          :id="'loadingQuitarCP' + conta.id"
          class="w-full vs-con-loading__container"
      >
        <div
            :id="'loadingSelectsQuitCP' + conta.id"
            class="w-full vs-con-loading__container"
        >
          <vs-row
              vs-align="center"
              vs-justify="center"
              vs-type="flex"
              vs-w="12"
          >
            <vs-col
                vs-align="flex-start"
                vs-justify="flex-start"
                vs-type="flex"
                vs-w="12"
            >
              <div>
                <vs-input
                    v-model="movimento.id_conta"
                    v-currency="$currencyFormatterOptions"
                    :disabled="true"
                    class="mx-1"
                    color="dark"
                    label="Número da Conta"
                    name="valor"
                    style="color: black; width: 181px"
                    type="text"
                ></vs-input>
              </div>
              <div>
                <label class="m-0 pl-3" style="color: black; font-size: 0.85rem"
                >Portador</label
                >
                <br/>
                <el-select
                    v-model="movimento.id_portador"
                    :popper-append-to-body="false"
                    class="mx-1 mt-2"
                    clearable
                    filterable
                    name="portador"
                    placeholder="Portador"
                    style="width: 181px"
                >
                  <el-option
                      v-for="portador in portadores"
                      :key="portador.id"
                      :label="portador.nome"
                      :value="portador.id"
                  ></el-option>
                </el-select>
              </div>
              <div>
                <label class="m-0 pl-3" style="color: black; font-size: 0.85rem">Plano Conta</label>
                <br/>
                <el-select
                    v-model="movimento.id_plano_conta"
                    :loading="loading"
                    :popper-append-to-body="false"
                    :remote-method="filtroPlanoConta"
                    class="mx-1 mt-2"
                    clearable
                    filterable
                    name="plano_conta"
                    placeholder="Pesquise"
                    remote
                    style="width: 181px"
                >
                  <el-option
                      v-for="data in plano_conta"
                      :key="data.id"
                      :label="data.nome"
                      :value="data.id"
                  ></el-option>
                </el-select>
              </div>
            </vs-col>
          </vs-row>
        </div>
        <vs-row
            class="mt-4"
            vs-align="center"
            vs-justify="center"
            vs-type="flex"
            vs-w="12"
        >
          <vs-col
              vs-="flex-start"
              vs-justifyalign="flex-start"
              vs-type="flex"
              vs-w="12"
          >
            <div>
              <vs-input
                  v-model="movimento.valor"
                  v-currency="$currencyFormatterOptions"
                  class="mx-1"
                  color="dark"
                  icon="R$"
                  icon-after="true"
                  label="Valor do Pagamento"
                  name="valor"
                  style="width: 181px"
                  type="text"
              ></vs-input>
            </div>
            <div>
              <vs-input
                  v-model="movimento.juros"
                  class="mx-1"
                  color="dark"
                  icon="R$"
                  icon-after="true"
                  label="Juros"
                  min="0"
                  name="valor"
                  style="width: 181px"
                  type="text"
              ></vs-input>
            </div>
            <div>
              <vs-input
                  v-model="movimento.data"
                  class="mx-2"
                  color="dark"
                  label="Data da Quitação"
                  name="emissao"
                  style="width: 181px"
                  type="date"
                  @change="checkData"
              ></vs-input>
            </div>
          </vs-col>
        </vs-row>
        <vs-row
            class="mb-2"
            vs-align="center"
            vs-justify="center"
            vs-type="flex"
            vs-w="12"
        >
          <vs-col
              vs-align="flex-end"
              vs-justify="flex-start"
              vs-type="flex"
              vs-w="12"
          >
            <vs-input
                v-model="movimento.obs"
                class="mx-1 w-full mt-4"
                color="dark"
                label="Observação"
                style="width: 600px"
                type="text"
            ></vs-input>
          </vs-col>
        </vs-row>
        <vs-row vs-align="center" vs-justify="center" vs-type="flex" vs-w="12">
          <vs-col
              vs-align="flex-start"
              vs-justify="flex-start"
              vs-type="flex"
              vs-w="12"
          >
            <vs-button
                class="w-full mt-3"
                color="success"
                type="relief"
                @click="submitForm()"
            >Quitar
            </vs-button
            >
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";

export default {
  props: {
    conta: {}
  },
  data() {
    return {
      modalQuitar: false,
      movimento: {},
      portadores: {},
      plano_conta: {},
      loading: false,
      open: false
    };
  },
  methods: {
    async openModal() {
      this.open = await true;
      this.modalQuitar = await true;
      await this.$vs.loading({
        container: "#loadingSelectsQuitCP" + this.conta.id,
        scale: 0.6
      });
      try {
        await this.getPortadores();
        await this.getPlanoContaByQuery(this.conta.id_plano_conta);
        await this.setObject();
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      } finally {
        await this.$vs.loading.close(
            "#loadingSelectsQuitCP" + this.conta.id + "> .con-vs-loading"
        );
      }
    },
    async submitForm() {
      try {
        if (
            this.movimento.id_portador != null &&
            this.movimento.id_plano_conta != null &&
            this.movimento.valor != null &&
            this.movimento.data != null && this.movimento.data != "" && this.movimento.data != undefined
        ) {
          await this.Quitar();
        } else {
          this.$vs.notify({
            title: "Preencha os campos obrigatorios",
            text: "Portador <br> Plano Conta <br> Valor <br> Data",
            color: "danger"
          });
        }
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      }
    },
    async Quitar() {
      await this.$vs.loading({
        container: "#loadingQuitarCP" + this.conta.id,
        scale: 0.6
      });
      try {
        let valor = "" + this.movimento.valor;
        if (valor && valor.search(",") !== -1) {
          valor = valor.replace(/\./g, "");
          valor = valor.replace(/,/g, ".");
        }
        this.movimento.valor = valor;
        let juros = "" + this.movimento.juros;
        if (juros && juros.search(",") !== -1) {
          juros = juros.replace(/\./g, "");
          juros = juros.replace(/,/g, ".");
        }
        this.movimento.juros = juros;
        await this.$http.post("quitarConta/" + this.conta.id, [
          this.movimento,
          this.conta
        ]);
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: "atualizar",
          setor: "financeiro",
          ip: window.localStorage.getItem("ip"),
          texto: "Quitação da Conta a Pagar N°" + this.conta.id
        };
        await this.$logger(logData);
        this.modalQuitar = await false;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      } finally {
        await this.$vs.loading.close(
            "#loadingQuitarCP" + this.conta.id + " > .con-vs-loading"
        );
        await this.$emit("update");
        this.modalQuitar = await false;
        this.open = await false;
      }
    },
    async setObject() {
      let hoje = this.$formartData.dataFiltro();
      let valor = (
          parseFloat(this.conta.valor) - (parseFloat(this.conta.valor_pago) || 0)
      ).toFixed(2);
      valor = valor.replace(/\./g, ",");
      this.movimento = {
        id_conta: this.conta.id,
        id_cliente: this.conta.id_cliente,
        id_empresa: this.conta.id_empresa,
        id_portador: this.conta.id_portador,
        id_fornecedor: this.conta.id_fornecedor,
        id_forma_pagamento: this.conta.id_forma_pagamento,
        id_plano_conta: this.conta.id_plano_conta,
        tipo_movimento: 1,
        obs: this.conta.obs,
        valor: parseFloat(valor) > 0 ? valor : 0,
        juros: 0,
        data: hoje
      };
    },
    async getPortadores() {
      try {
        this.portadores = await this.$http.get(`portador`);
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      }
    },
    async getPlanoContaByQuery(query) {
      try {
        this.plano_conta = await this.$http.post(`getPlanoContaByQuery`, {
          query: query
        });
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
        ;
      }
    },
    async filtroPlanoConta(query) {
      if (query.length > 2) {
        this.loading = true;
        try {
          await this.getPlanoContaByQuery(query);
        } catch (err) {
          const error = this.$httpErrors(err);
          this.$vs.notify(error);
          if (error.code == 401) {
            await window.localStorage.clear();
            await this.$router.push("/");
          }
          ;
        } finally {
          this.loading = false;
        }
      }
    },
    async checkData() {
      if (this.$atividades.permissoes.includes(25)) {
        return 1;
      }
      var hoje = new Date();
      var data = new Date(this.movimento.data);

      var dia_hoje = hoje.getUTCDate();
      var mes_hoje = hoje.getUTCMonth() + 1;
      var dia_data = data.getUTCDate();
      var mes_data = data.getUTCMonth() + 1;
      var ano_hoje = hoje.getUTCFullYear();
      var ano_data = data.getUTCFullYear();

      console.log("dia_hoje - " + dia_hoje);
      console.log("mes_hoje - " + mes_hoje);
      console.log("dia_data - " + dia_data);
      console.log("mes_data - " + mes_data);
      console.log("ano_hoje - " + ano_hoje);
      console.log("ano_data - " + ano_data);
      if (ano_data < ano_hoje && 0) {
        this.movimento.data = hoje.toISOString().split("T")[0];
        this.$vs.notify({
          title: "Não é possível movimentar o ano anterior. ERR COD 03",
          text: "Ação Negada",
          color: "danger"
        });
        let logData = {
          id_colaborador: localStorage.getItem("id"),
          funcao: "burl",
          setor: "financeiro",
          ip: window.localStorage.getItem("ip"),
          texto:
              "Tentou quitar para uma data anterior da conta pagar N°" +
              this.conta.id
        };
        await this.$logger(logData);
        return 1;
      }
      if (dia_hoje > 5) {
        if (mes_data < mes_hoje) {
          this.movimento.data = hoje.toISOString().split("T")[0];
          this.$vs.notify({
            title: "Não é possível movimentar o mês anterior. ERR COD 01",
            text: "Ação Negada",
            color: "danger"
          });
          let logData = {
            id_colaborador: localStorage.getItem("id"),
            funcao: "burl",
            setor: "financeiro",
            ip: window.localStorage.getItem("ip"),
            texto:
                "Tentou quitar para uma data anterior da conta pagar N°" +
                this.conta.id
          };
          await this.$logger(logData);
          return 1;
        }
      } else {
        if (mes_hoje + 1 < mes_data && !(mes_hoje == 1 && mes_data == 12)) {
          this.movimento.data = hoje.toISOString().split("T")[0];
          this.$vs.notify({
            title: "Não é possível movimentar o mês anterior. ERR COD 02",
            text: "Ação Negada",
            color: "danger"
          });
          let logData = {
            id_colaborador: localStorage.getItem("id"),
            funcao: "burl",
            setor: "financeiro",
            ip: window.localStorage.getItem("ip"),
            texto:
                "Tentou quitar para uma data anterior da conta pagar N°" +
                this.conta.id
          };
          await this.$logger(logData);
          return 1;
        }
      }
    }
  },
  async mounted() {
    await this.openModal();
  },
  components: {...components}
};
</script>
